import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AlertController} from "ionic-angular";
import {UtilProvider} from "../../providers/util/util";

/**
 * Generated class for the ChatroomPickerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'chatroom-picker',
  templateUrl: 'chatroom-picker.html'
})
export class ChatroomPickerComponent {

  //数据源
  @Input('groupList') groupList = [];

  //反馈结果
  @Output('onFinished') onFinished = new EventEmitter();

  constructor(public util: UtilProvider,
              private alertCtrl: AlertController) {
    console.log('Hello ChatroomPickerComponent Component');
  }

  //选中组的集合
  showSet = new Set();
  /**
   * 展开关闭组*/
  toggleShowGroup(group) {
    if (this.showSet.has(group.group_id)) {
      this.showSet.delete(group.group_id);
    } else {
      this.showSet.add(group.group_id);
    }
  }

  /**
   * 开关组时更新组里的 chatroom状态*/
  toggleChooseGroup(group) {
    if (this.isChoosedGroup(group)) {
      group.chatroom_list.forEach(item => (item.is_choosed = false));
    } else {
      group.chatroom_list.forEach(item => (item.is_choosed = true));
    }
  }

  /**
   * 组是否被选择*/
  isChoosedGroup(group) {
    return group.chatroom_list.every(item => item.is_choosed);
  }

  /**
   * 开关微信群*/
  toggleChooseChatroom(chatroom) {
    chatroom.is_choosed = !chatroom.is_choosed;
  }

  /**
   * 已经选择的微信群*/
  groupChoosedChatroom(group) {
    return group.chatroom_list.filter(chatroom => chatroom.is_choosed);
  }

  /**
   * 错误群头像*/
  errorChatroomAvatar(chatroom) {
    chatroom.avatar_url = './assets/imgs/group_nor.jpg';
  }

  /**
   * 点击全选*/
  toggleAll(){
    if(!this.isChoosedAll()){
      this.groupList.forEach(value => {
        if(!this.isChoosedGroup(value)) this.toggleChooseGroup(value);
      });
    } else {
      this.groupList.forEach(value => {
        if(this.isChoosedGroup(value)) this.toggleChooseGroup(value);
      });
    }

  }

  /**
   * 是否全选*/
  isChoosedAll(){
    return this.groupList.length>0 && this.groupList.every(value => this.isChoosedGroup(value));
  }

  /**
   * 提交选群，供上层调用*/
  public submit(){
    let chatroomnames = [];
    this.groupList.forEach(group =>{
      chatroomnames = chatroomnames.concat(group.chatroom_list.filter(value => value.is_choosed));
    });

    if(chatroomnames.length>0){
      this.onFinished.emit(chatroomnames);
    } else {
      this.util.alertHintMsg(this.alertCtrl, '提示', '请选择目标微信群');
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/chatroom-picker/chatroom-picker.ts